import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type ThemeMode = "light" | "dark";

interface ThemeState {
  mode: ThemeMode;
  toggle: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: "light",
      toggle: (): void => {
        set((state) => ({ mode: state.mode === "light" ? "dark" : "light" }));
      },
    }),
    {
      name: "bakery-theme",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
